import { render, staticRenderFns } from "./CoreGroupbuyList.vue?vue&type=template&id=326cec90&"
import script from "./CoreGroupbuyList.vue?vue&type=script&lang=js&"
export * from "./CoreGroupbuyList.vue?vue&type=script&lang=js&"
import style0 from "./CoreGroupbuyList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports